/* Viklund - VAT gate (snippets/vk-vat-gate.liquid).

   Guest carts only; the snippet renders nothing for a signed-in customer, so
   with no field on the page every function here is a no-op.

   THIS IS A FUNNEL, NOT ENFORCEMENT. The disabled attribute is a hint to an
   honest visitor. Deleting it in devtools, opening /checkout directly, using
   an express checkout button or driving the Storefront API all bypass it, and
   that is a known, accepted trade-off. Server-side enforcement would be a
   Cart and Checkout Validation Function, which does not exist yet.

   Everything is delegated from document rather than bound to the elements:
   cart.js replaces the cart page contents and the whole .cart-drawer__footer
   on every quantity change, so any listener bound directly to the field or
   the checkout button would be thrown away mid-session.

   The initial disabled state is rendered by Liquid, not by this script, from
   whether the cart already carries the attribute. That way a re-render lands
   in the right state before this file has run, and the gate still holds with
   JS blocked (the field is a real form field on the checkout form). */
(function () {
  if (window.vkVatGateInit) return;
  window.vkVatGateInit = true;

  // Format only, by design. Two letters plus 8 to 12 alphanumeric covers the
  // EU VAT shapes; NNNNNNN-N is the Finnish Y-tunnus, which has no country
  // prefix and would otherwise be rejected.
  var EU_VAT = /^[A-Z]{2}[A-Z0-9]{8,12}$/;
  var FI_BUSINESS_ID = /^[0-9]{7}-[0-9]$/;
  var SAVE_DELAY = 600;

  var saveTimer = null;
  var lastSaved = null;

  function normalise(value) {
    // People paste "FI 1234 5678". Spacing is presentation, not identity.
    return (value || '').replace(/\s+/g, '').toUpperCase();
  }

  function isValid(value) {
    var v = normalise(value);
    return EU_VAT.test(v) || FI_BUSINESS_ID.test(v);
  }

  function inputs() {
    return document.querySelectorAll('[data-vk-vat-input]');
  }

  function checkoutButtons() {
    return document.querySelectorAll('#checkout, #CartDrawer-Checkout');
  }

  function showError(show) {
    var nodes = document.querySelectorAll('[data-vk-vat]');
    for (var i = 0; i < nodes.length; i++) {
      var box = nodes[i].querySelector('[data-vk-vat-error]');
      if (!box) continue;
      if (show) {
        box.textContent = nodes[i].getAttribute('data-vk-vat-message') || '';
        box.hidden = false;
      } else {
        box.textContent = '';
        box.hidden = true;
      }
    }
  }

  function syncButtons(ok) {
    var buttons = checkoutButtons();
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      // Never enable a button that Liquid disabled for its own reason. The
      // empty cart is marked server-side rather than guessed from the DOM.
      if (button.hasAttribute('data-vk-cart-empty')) continue;
      if (ok) {
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('disabled', 'disabled');
      }
    }
  }

  function persist(value) {
    if (value === lastSaved) return;
    lastSaved = value;
    var body = { attributes: {} };
    body.attributes.vat_number = value;
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/update.js'
      : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).catch(function () {
      // Offline or blocked: the field is still a form field on the checkout
      // form, so the attribute goes with the submit anyway. Nothing to say.
      lastSaved = null;
    });
  }

  function mirror(from) {
    var all = inputs();
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== from) all[i].value = from.value;
    }
  }

  function onEdit(event) {
    var field = event.target.closest ? event.target.closest('[data-vk-vat-input]') : null;
    if (!field) return;
    mirror(field);
    // "Clear it as soon as the user edits" - the error goes on the first
    // keystroke, before we know whether the new value is any better.
    showError(false);
    var ok = isValid(field.value);
    syncButtons(ok);
    if (saveTimer) clearTimeout(saveTimer);
    if (ok) {
      var value = normalise(field.value);
      saveTimer = setTimeout(function () { persist(value); }, SAVE_DELAY);
    }
  }

  function onLeave(event) {
    var field = event.target.closest ? event.target.closest('[data-vk-vat-input]') : null;
    if (!field) return;
    // Empty is "not finished", not "wrong". Only a filled, malformed value
    // earns an error message.
    if (field.value.trim() !== '' && !isValid(field.value)) showError(true);
  }

  function onSubmitAttempt(event) {
    var button = event.target.closest
      ? event.target.closest('#checkout, #CartDrawer-Checkout')
      : null;
    if (!button) return;
    var field = inputs()[0];
    if (!field) return; // signed in: no gate
    if (isValid(field.value)) return;
    event.preventDefault();
    showError(field.value.trim() !== '');
    syncButtons(false);
    field.focus();
  }

  function sync() {
    var field = inputs()[0];
    if (!field) return; // signed in, or no cart on this page
    syncButtons(isValid(field.value));
  }

  document.addEventListener('input', onEdit);
  document.addEventListener('focusout', onLeave, true);
  document.addEventListener('click', onSubmitAttempt, true);
  document.addEventListener('shopify:section:load', sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
